export default "__VITE_ASSET__9SPk0nkD__"